export function formatCommaSeparatedString(items: string[]): string {
  return (
    items.slice(0, -1).join(', ') +
    (items.length > 1 ? ', ' : '') +
    items.slice(-1) +
    '.'
  );
}
